/** Remove a user from the tenant (revoke tenant membership). */
export const tenantUserDeleteSpec = {
    uri: '/t/[tenant]/user/[user]',
    method: 'DELETE',
};
